import { Component, OnInit } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ArticlesService} from '../../../shared/service/articles.service';
import {SnackService} from '../../../shared/components/snack/snack.service';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html'
})
export class ContactFormComponent implements OnInit {

  constructor( private _articleService: ArticlesService,
               private _snack: SnackService,) { }

  ngOnInit(): void {
  }
  contactForm = new UntypedFormGroup({
    fullName: new UntypedFormControl(null, Validators.required),
    email: new UntypedFormControl(null, Validators.required),
    phoneNumber: new UntypedFormControl(null, Validators.required),
    message: new UntypedFormControl(null, Validators.required),
  });

  save(){
    this._articleService.sendContact(this.contactForm.value).subscribe(res => {
      if(res.success){
        this._snack.showSnack('COMMON.SEND_SUCCESS', 'success');
        this.contactForm.reset();
      }
    })
  }
}
